export default "/eb1b73cf75f302d63b0b9bd9835c1038cae47005/78489dd5fe22b2b724f99f5861a7cee7.svg";